import { AlertTriangle, Loader2, Trash2 } from 'lucide-react'

export default function DeleteExpenseModal({ error, isSubmitting, onClose, onConfirm, expense }) {
  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-[#1A1A1A]/35 p-4 backdrop-blur-[5px]"
      role="presentation"
      onMouseDown={onClose}
    >
      <section
        className="w-full max-w-[480px] overflow-hidden rounded-xl bg-white text-center shadow-[0_22px_55px_rgba(17,24,39,0.22)]"
        role="dialog"
        aria-modal="true"
        onMouseDown={(event) => event.stopPropagation()}
      >
        <div className="px-5 py-8 sm:px-8 sm:py-10">
          <div className="mx-auto mb-6 flex h-16 w-16 items-center justify-center rounded-xl bg-[#FFE0DE] text-[#C91D1D]">
            <AlertTriangle size={34} strokeWidth={2.2} aria-hidden="true" />
          </div>

          <h2 className="text-2xl font-semibold tracking-normal text-[#1A1A1A]">
            Excluir Saída
          </h2>
          <p className="mx-auto mt-4 max-w-[390px] text-base leading-7 text-[#1A1A1A]">
            Tem certeza que deseja excluir o registro de{' '}
            <strong className="font-bold">{expense.description}</strong>? Esta ação não pode ser
            desfeita.
          </p>

          {error ? (
            <div className="mx-auto mt-5 max-w-[390px] rounded-md border border-red-200 bg-red-50 px-3 py-2.5 text-left text-sm font-medium text-red-700">
              {error}
            </div>
          ) : null}
        </div>

        <div className="flex min-h-[86px] flex-col-reverse items-stretch justify-center gap-3 border-t border-[#E5DED3] bg-[#FBFAF8] px-5 py-5 sm:flex-row sm:items-center sm:gap-8 sm:px-6 sm:py-0">
          <button
            className="h-10 px-4 text-sm font-semibold tracking-[0.04em] text-[#1A1A1A]"
            type="button"
            onClick={onClose}
          >
            Cancelar
          </button>
          <button
            className="flex h-10 min-w-0 items-center justify-center gap-2 rounded-md bg-[#C91D1D] px-5 text-sm font-bold tracking-[0.02em] text-white shadow-sm transition hover:bg-[#A91616] disabled:cursor-not-allowed disabled:opacity-70 sm:min-w-[190px]"
            disabled={isSubmitting}
            type="button"
            onClick={onConfirm}
          >
            {isSubmitting ? <Loader2 className="animate-spin" size={16} /> : <Trash2 size={16} />}
            Excluir
          </button>
        </div>
      </section>
    </div>
  )
}
